import { get } from "../../../service/api";

export const getCepApi = ({ cep, token }) => {
  return get(`https://brasilapi.com.br/api/cep/v1/${cep}`, token);
};
